import { ReportInfoCard } from "st-app/api";
import Dropdown from "../st-dropdown/st-dropdown";
import ButtonGroup from "../st-button-group/st-button-group";
import Button, { ButtonType } from "../st-button/st-button";
import { useReportBrowser } from "./report-browser-context";
import { Show, Signal, createSignal } from "solid-js";

interface ReportEditMenuProps {
    report: ReportInfoCard
    isOpen?: Signal<boolean>
}

export default function ReportEditMenu(props: ReportEditMenuProps) {
    const reportBrowser = useReportBrowser()!;

    const launchDesigner = (e: MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
        reportBrowser.launchReportDesigner(props.report)
    }

    const isOpen = props.isOpen ?? createSignal(false)

    return <Show when={reportBrowser.state.isEditing}>
        <ButtonGroup>
            <Button enabled={props.report.canEdit} onClick={launchDesigner}>
                Edit
            </Button>
            <Dropdown placement='bottom-end' open={isOpen}>
                <Dropdown.Trigger as={Button}>
                    <span class="fa fa-chevron-down"></span>
                </Dropdown.Trigger>
                <Dropdown.Content>
                    <div class="report-browser-dropdown-menu">
                        <ButtonGroup vertical>
                            <Button enabled={props.report.canCopy} onClick={() => reportBrowser.openCopyDialog(props.report)} >
                                Copy
                            </Button>
                            <Button onClick={() => reportBrowser.openReportThumbnailDialog(props.report)}>
                                Thumbnail
                            </Button>
                            <Button enabled={props.report.canEdit && reportBrowser.state.canPublish} onClick={() => reportBrowser.openPublishDialog(props.report)}>
                                Publish
                            </Button>
                            <Button enabled={props.report.canEdit} onClick={() => reportBrowser.openDeleteDialog(props.report)} type="danger">
                                Delete
                            </Button>
                        </ButtonGroup>
                    </div>
                </Dropdown.Content>
            </Dropdown>
        </ButtonGroup>
    </Show>
}
